import { defineStore } from 'pinia'
import { ref } from 'vue'
import { asyncRoutes } from '@/router/routes'

function hasPermission(roles, route) {
  if (route.meta?.roles) {
    return roles.some((role) => route.meta.roles.includes(role))
  }
  return true
}

function filterAsyncRouter(routes, roles) {
  return routes
    .filter((route) => hasPermission(roles, route))
    .map((route) => {
      const r = { ...route }
      if (r.children?.length) {
        r.children = filterAsyncRouter(r.children, roles)
      }
      return r
    })
}

export const usePermissionStore = defineStore('permission', () => {
  const addRouters = ref([])
  const routesAdded = ref(false)

  function generateRoutes(roles) {
    const accessed =
      roles.includes('admin') ? asyncRoutes : filterAsyncRouter(asyncRoutes, roles)
    addRouters.value = accessed
    return accessed
  }

  function reset() {
    addRouters.value = []
    routesAdded.value = false
  }

  return {
    addRouters,
    routesAdded,
    generateRoutes,
    reset
  }
})
